<template>
  <!--  导航-->
  <div class="nav-container">
    <div class="line-one search-map">
      <div class="line-title"> 起始地：</div>
      <el-input v-model="navForm.starting" placeholder="急救车（默认地点）"/>
      <!--      <img src="../assets/photos/arrow.png" alt="">-->
      <div class="line-title"> 目的地：</div>
      <el-input
        v-model="navForm.destination"
        placeholder="（终点）"
        @keyup.native.enter="searchMap"
      />
      <el-button
        class="my-button"
        @click="searchMap"
      >
        搜索
      </el-button>
      <!--      <div class="" @click="syncMap">-->
      <!--        发送至移动端-->
      <!--      </div>-->
      <!--        <div class="navBgd" @click="goBackCar">-->
      <!--          <img src="../assets/photos/Navigation.png" alt="">-->
      <!--        </div>-->
      <transition name="fade" mode="out-in">
        <popup-detail
          v-if="showPopup"
          class="popup-detail"
          :three-data="popupData"
          @closePopup="showPopup=false"
          @setRoad="setRoad"
        />
      </transition>
    </div>

    <el-row>
      <el-col :span="24">
        <div class="predicateTime">
          预计花费时间：
          <span>{{ leftTime || 0 }}分钟</span>
        </div>
        <div class="grid-content">
          <nav-map
            v-if="carID"
            :car-i-d="carID"
            :nav-form="navForm"
            :back-home="backHome"
            :count="keepCount"
            :category="category"
            @getLeftTime="getLeftTime"
            @getPopupData="getPopupData"
          />
        </div>
      </el-col>

    </el-row>

    <!-- 同步成功弹窗 -->
    <!--    <my-dialog-->
    <!--      :width="390"-->
    <!--      :dialog-carted="dialogSuccess"-->
    <!--      title="提示"-->
    <!--      @confirmOk="dialogSuccess = false"-->
    <!--    >-->
    <!--      <template #content>-->
    <!--        <div>{{ syncTips }}</div>-->
    <!--      </template>-->
    <!--    </my-dialog>-->

    <!-- 路径规划弹窗 -->
    <my-dialog
      :width="390"
      :dialog-carted="dialogInfo"
      title="提示"
      @confirmOk="dialogInfo = false"
    >
      <template #content>
        <div>必须输入终点站才能规划！</div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import { longLatiToAddress } from "@utils/basic";
import MyDialog from "@components/customDialog/MyDialog.vue";
import NavMap from "@components/MapContainer/NavMap";
import { mapState } from "vuex";
import PopupDetail from "@views/Navigation/PopupDetail";
import { sendNavigation } from "@api/navigation";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "Navigation",
  components: {
    PopupDetail,
    NavMap,
    MyDialog,
  },
  data() {
    return {
      popupData: [], // 三条规划的数据
      showPopup: false, // 展示路劲规划
      syncTips: "", // 同步消息框
      navigationForm: {
        ambulanceId: "",
        details: "",
        startL: "",
      },
      keepCount: 0, // 跟子组件通信, 增加就代表搜索，
      navForm: {
        starting: "",
        destination: "",
        type: 0, // 0表示获取三条 规划路线, 1表示导航
        index: "", // 点击导航规划, 元素的位置
      },
      centerMapPoint: [], // 经纬度 [经度, 纬度]
      carID: 0, // 急救车ID
      dialogSuccess: false,
      dialogInfo: false,
      leftTime: "", // 急救车返程时间
      backHome: 0, // 变动则表示点了回到急救车定位
      category: "",
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
    })
  },
  async mounted() {
    const { id } = this.$route.params;
    this.carID = id * 1;
    this.getSCoordinate();
    let starting = await longLatiToAddress(...this.centerMapPoint);
    if (starting.length === 0) {
      starting = "";
    }
    this.navForm.starting = starting;
    this.category = this.$route.query.category;

    // // fixme: 手动先
    // const data2 = JSON.parse(localStorage.getItem("ooo"));
    // this.popupData = data2;
  },
  methods: {
    /**
     * 设置路线
     * @param {string} val - 点击的index
     * */
    setRoad(val) {
      this.navForm.type = 1;
      this.navForm.index = val;
      this.keepCount++;
      this.showPopup = false;
      this.syncMap();
    },
    /**
     * 点击搜索拿到不同的规划数据
     * */
    getPopupData(data) {
      this.popupData = data;
      this.showPopup = true;
    },
    searchMap() {
      if (this.navForm.destination === "") {
        this.dialogInfo = true;
        return;
      }
      this.navForm.type = 0;
      this.keepCount++;
    },
    // 发送至移动端
    async syncMap() {
      try {
        const { destination, starting } = this.navForm;
        this.navigationForm = {
          ambulanceId: this.carID,
          details: destination,
          startL: starting,
        };
        const { code } = await sendNavigation(this.navigationForm);
        console.log(code);
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    goBackCar() {
      // 当急救车默认地点被点击后,自动定位回急救车地点
      this.backHome++;
    },
    // 拿急救车经纬度
    getSCoordinate() {
      this.ambulanceLists.forEach(({ longitude, id, latitude }) => {
        if (id === this.carID) {
          this.centerMapPoint = [longitude, latitude];
        }
      });
    },
    getLeftTime(leftTime) {
      this.leftTime = Math.round(leftTime / 60);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-main .el-footer {
  margin: -6px !important;
}

.nav-container {
  width: 100%;
}

.line-title {
  font-size: 16px;
  color: #666666;
}

.predicateTime {
  position: absolute;
  left: 10px;
  bottom: 4px;
  width: 280px;
  height: 50px;
  background: #efefef;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
  z-index: 161;
  text-align: center;
  vertical-align: bottom;
  line-height: 50px;
  font-size: 22px;
  font-weight: bold;
  color: #666666;
}

.line-one {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-top: 12px;
  background-color: #FBFBFB;
  margin-bottom: 24px;

  .el-input {
    line-height: 76px;
    width: 200px;

    ::v-deep .el-input__inner {
      width: 180px;
      height: 32px;
      border: 1px solid #999999;
      border-radius: 10px;
    }
  }

  .my-button {
    border: 1px solid #75B8E6;
    border-radius: 8px;
    font-size: 16px;
    color: #75B8E6;
    height: 16px;
  }
}

.search-map {
  position: relative;

  .popup-detail {
    position: absolute;
    top: 65px;
    left: 0;
    width: 746px;
    height: 242px;
    background: #FBFBFB;
    box-shadow: 0 0 8px 0 rgba(127, 147, 166, 0.4);
    border-radius: 10px;
    z-index: 161;

    display: flex;
    flex-direction: column;
    justify-content: center;


    list-style-type: none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out; /* 过渡效果 */
}

.fade-enter,
.fade-leave-to {
  opacity: 0; /* 进入和离开时的初始状态 */
}
</style>
